import type { CompanyReportSection } from '@/pages/CompanyReport/useSection';
import { GridViewOptions } from '@/pages/CompanyReport/constants/constants';

/**
 * @deprecated Instead pass the title directly in the calling section component
 */
export const getTitleBySection = (section: CompanyReportSection) => {
  const SECTIONS_TITLE_MAP = {
    future: 'Discover growth companies',
    past: 'Discover strong past performing companies',
    health: 'Discover healthy companies',
    dividend: 'Discover strong dividend paying companies',
  };

  return SECTIONS_TITLE_MAP[section];
};

export const getGridViewOptionIdBySection = (section: CompanyReportSection) => {
  const SECTIONS_GRID_VIEW_ID_MAP = {
    valuation: GridViewOptions.GRID_VIEW_POTENTIALLY_UNDERVALUED,
    future: GridViewOptions.GRID_VIEW_HIGH_GROWTH,
    past: GridViewOptions.GRID_VIEW_STRONG_PAST_PERFORMING,
    health: GridViewOptions.GRID_VIEW_HEALTHY,
    dividend: GridViewOptions.GRID_VIEW_DIVIDEND_NEW,
  };

  return SECTIONS_GRID_VIEW_ID_MAP[section];
};
